import axios from "axios";
import fileDownload from "js-file-download";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";

const getAllForecasts = async (params: any) => {
  const { data: response } = await axios.get(endpoints.FORECAST, {
    headers: {
      Authorization: accessToken,
    },
    params,
  });

  return response;
};

const viewForecast = async (id: number | string) => {
  const { data: response } = await axios.get(`${endpoints.FORECAST}/${id}`, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const createForecast = async (params: {
  region_id: number;
  month: number;
  year: number;
  roll_count_beginning: number;
  kertas_count_beginning: number;
  roll_count_end: number;
  kertas_count_end: number;
  used_kertas: number;
}) => {
  const { data: response } = await axios.post(endpoints.FORECAST, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const updateForecast = async (params: { id: number | string;[key: string]: any }) => {
  const { id, ...body } = params;
  const { data: response } = await axios.patch(`${endpoints.FORECAST}/${id}`, body, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const deleteForecast = async (id: number | string) => {
  const { data: response } = await axios.delete(`${endpoints.FORECAST}/${id}`, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const downloadForecast = async (params: any) => {
  const { data } = await axios.get(`${endpoints.FORECAST}/download`, {
    headers: {
      Authorization: accessToken,
      ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
    params,
    responseType: "arraybuffer",
  });

  const blob = new Blob([data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  fileDownload(blob, "forecast.xlsx");
};

const uploadForecast = async (file: File) => {
  const formData = new FormData();
  formData.append("file", file);

  const { data: response } = await axios.post(`${endpoints.FORECAST}/upload`, formData, {
    headers: {
      Authorization: accessToken,
      "Content-Type": "multipart/form-data",
    },
  });

  return response;
};

const createPurchaseFromForecast = async (params: any) => {
  const { data: response } = await axios.post(`${endpoints.FORECAST}/create-purchase`, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const forecastService = {
  getAllForecasts,
  viewForecast,
  createForecast,
  updateForecast,
  deleteForecast,
  downloadForecast,
  uploadForecast,
  createPurchaseFromForecast,
};

export default forecastService;